// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__mE12n","mark":"Logo_mark__FftOy","text":"Logo_text__aky56"};